import { Component, OnDestroy, OnInit, Optional, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { finalize, Subject, takeUntil } from 'rxjs';
import { FuseConfigService } from '@fuse/services/config';
import { AppConfig, Scheme, Theme, Themes } from 'app/core/config/app.config';
import { Layout } from 'app/layout/layout.types';
import { ImageCroppedEvent } from 'ngx-image-cropper';
import { UserService } from 'app/core/user/user.service';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector     : 'update-photo',
    templateUrl  : './update-photo.component.html',
    styles       : [
    `
    p {
  font-family: Lato;
}

.image-container {
  position: relative;
  display: inline-block;
  text-align: center;
}

.hoverable img {
  
display: flex;
justify-content: center; /* Centraliza horizontalmente */
align-items: center; /* Centraliza verticalmente */
height: 200px;
width: 200px;
border: 1px dashed #808080; /* Borda tracejada cinza */
border-radius: 50%;

}

.hoverable i {
  
display: flex;
justify-content: center; /* Centraliza horizontalmente */
align-items: center; /* Centraliza verticalmente */
height: 200px;
width: 200px;
border: 1px dashed #808080; /* Borda tracejada cinza */
border-radius: 50%;

}

.select-profile-picture {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 999;
  opacity: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
}

   
.mat-mdc-dialog-container .mat-mdc-dialog-surface {
padding: 0 !important;
}

       `
    ]
})
export class UpdatePhotoComponent implements OnInit
{
    @ViewChild('fileInput') fileInput;
    imageChangedEvent: any = '';
    croppedImage: any = '';
    profileImage = '';
    /**
     * Constructor
     */
    constructor(
        private _router: Router,
        private _fuseConfigService: FuseConfigService,
        private _userService: UserService,
        @Optional() public matDialogRef: MatDialogRef<UpdatePhotoComponent>,
        
    )
    {
    }
    name = 'Angular ';
    url: any = '';
    onSelectFile(event) {
      if (event.target.files && event.target.files[0]) {
        var reader = new FileReader();
  
        reader.readAsDataURL(event.target.files[0]); // read file as data url
  
        reader.onload = (event) => {
          // called once readAsDataURL is completed
          this.url = event.target.result;
          console.log(this.url);
        };
      }
    }
    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {
    }

    triggerFileInput() {
            this.fileInput.native;
    }
        
    
  fileChangeEvent(event: any): void {
        this.imageChangedEvent = event;
      }
    
      
    imageCropped(event: ImageCroppedEvent) {
        this.croppedImage = event.base64;
      }
    
    
      imageLoaded() {
        // show cropper
      }
    
      cropperReady() {
        // cropper ready
      }
    
      loadImageFailed() {
        // show message
      }
    

    save() {
        this._userService.updatePhoto(this.url)
        .pipe(finalize(() => {
        }))
        .subscribe((response: any) => {
            this.matDialogRef.close();
        });
    }

    remove() {
        this._userService.updatePhoto('')
        .pipe(finalize(() => {
        }))
        .subscribe((response: any) => {
            this.matDialogRef.close();
        });
    }
}
